<template>
  <Dialog
    :visible="dialogVisible"
    title="设置聚合类型"
    @close="handleClose"
    width="600px"
  >
    <CheckboxGroup v-model="selected">
      <Checkbox
        v-for="item in dataSource"
        :key="item.key"
        class="aggregate-checkbox"
        :label="item.key"
        :disabled="disabled.includes(item.key)"
      >
        {{ item.name }}
      </Checkbox>
    </CheckboxGroup>

    <span
      slot="footer"
      class="aggregate-footer"
    >
      <Button
        type="primary"
        @click="handleConfirm"
      >
        确定
      </Button>
      <Button @click="handleClose">取消</Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Checkbox, CheckboxGroup, Button } from 'element-ui';
import { flatten, uniq } from 'lodash';

import { dimensionFieldsList, branchFieldsList } from '../config/';

export default {
  components: {
    Dialog,
    Checkbox,
    CheckboxGroup,
    Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    defaultData: {
      type: Array,
      default() {
        return [];
      },
    },

    disabledData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialogVisible: this.visible,
      dataSource: dimensionFieldsList,
      selected: this.getDefaultData(),
    };
  },

  computed: {
    disabled() {
      // date 默认禁用
      return [...new Set(['date', ...this.disabledData])];
    },
  },

  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    defaultData: {
      handler: function(nv) {
        this.selected = this.getDefaultData();
      },
      deep: true,
    },
  },

  methods: {
    handleConfirm() {
      const keys = this.selected;
      const columns = this.getColumns();
      this.$emit('confirm', { keys, columns });
      this.handleClose();
    },

    handleClose() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
    },

    // 获取用于展示的表格列信息
    getColumns() {
      let columns = [];
      dimensionFieldsList.forEach((dimension) => {
        if (this.selected.includes(dimension.key)) {
          if (dimension.branches) {
            columns = columns.concat(dimension.branches);
          } else {
            columns.push(dimension);
          }
        }
      });
      return columns;
    },

    getDefaultData() {
      const mapping = {};
      flatten(branchFieldsList).forEach((item) => {
        mapping[item.key] = item.trunk;
      });

      const temp = this.defaultData.reduce((prev, current) => {
        mapping[current.key]
          ? prev.push(mapping[current.key])
          : prev.push(current.key);
        return prev;
      }, []);

      return uniq(temp);
    },
  },
};
</script>

<style lang="less" scoped>
.aggregate {
  &-checkbox {
    margin-bottom: 16px;
  }

  &-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
